module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide2bottom"
    }
  }, [(_vm.type === 'create' ? _vm.createShow : _vm.reviseShow) ? _c('div', {
    staticClass: "new-markdown"
  }, [_c('div', {
    staticClass: "dialog"
  }, [_c('div', {
    staticClass: "dialog-title"
  }, [_c('h4', [_vm._v(_vm._s(_vm.typeObject[_vm.type].dialogTile))])]), _c('div', {
    staticClass: "dialog-content"
  }, [_vm._l((_vm.fileInfoArr), function(v, i) {
    return _c('div', {
      staticClass: "input"
    }, [(i === 0) ? _c('span', {
      staticClass: "key"
    }, [_vm._v(_vm._s(v.key))]) : _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (v.key),
        expression: "v.key"
      }],
      staticClass: "key",
      attrs: {
        "spellcheck": "false"
      },
      domProps: {
        "value": _vm._s(v.key)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          v.key = $event.target.value
        }
      }
    }), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (v.value),
        expression: "v.value"
      }],
      staticClass: "value",
      attrs: {
        "spellcheck": "false"
      },
      domProps: {
        "value": _vm._s(v.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          v.value = $event.target.value
        }
      }
    }), (i != 0) ? _c('div', {
      staticClass: "addlink"
    }, [_c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [_c('input', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.linkInputShow[i]),
        expression: "linkInputShow[i]"
      }, {
        name: "model",
        rawName: "v-model",
        value: (v.link),
        expression: "v.link"
      }],
      staticClass: "link",
      attrs: {
        "spellcheck": "false",
        "type": "url",
        "placeholder": "请输入绑定链接"
      },
      domProps: {
        "value": _vm._s(v.link)
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          v.link = $event.target.value
        }
      }
    })]), _c('a', {
      staticClass: "iconfont icon-iconfontlink",
      on: {
        "click": function($event) {
          _vm.addLink(i)
        }
      }
    })], 1) : _vm._e(), (i === 0) ? [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.fileNameIsEmpty),
        expression: "fileNameIsEmpty"
      }],
      staticClass: "fileName-tip"
    }, [_vm._v("必填")]), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.hadRepeatFile),
        expression: "hadRepeatFile"
      }],
      staticClass: "fileName-tip"
    }, [_vm._v("重名")])] : _vm._e()], 2)
  }), _c('div', {
    staticClass: "tip"
  }, [_vm._v("第二个第三个key值可以自定义")])], 2), _c('div', {
    staticClass: "dialog-btns"
  }, [_c('a', {
    staticClass: "create",
    on: {
      "click": _vm.sureFn
    }
  }, [_vm._v(_vm._s(_vm.typeObject[_vm.type].sureBtn))]), _c('a', {
    staticClass: "cancel",
    on: {
      "click": _vm.cancelFn
    }
  }, [_vm._v(_vm._s(_vm.typeObject[_vm.type].cancelBtn))])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-4d1b6e2e"}!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/new-markdown/new-markdown.vue
// module id = 278
// module chunks = 1